<script>
export default {
  page() {
    return {
      title: this.user.profile.firstName + ' ' + this.user.profile.lastName,
      meta: [
        {
          name: 'description',
          content: `The user profile for ${this.user.profile.firstName} ${
            this.user.profile.lastName
          }.`,
        },
      ],
    }
  },
  components: {},
  props: {
    identity: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      profile: '',
    }
  },
  mounted() {},
  methods: {},
}
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-xl-4 col-lg-5 col-md-6">
          <b-card class="card-user">
            <div slot="image">
              <img src="" alt="..." />
            </div>
            <div>
              <div class="author">
                <img
                  :src="identity.profile.picture"
                  class="avatar border-white"
                  alt="..."
                />
                <h4 class="title">
                  {{
                    user.profile
                      ? user.profile.firstName
                      : identity.profile.given_name
                  }}
                  {{
                    user.profile
                      ? user.profile.lastName
                      : identity.profile.family_name
                  }}
                  <br />
                  <!-- <a href="#">
                    <small>@{{ user.profile.firstName.toLowerCase() }}</small>
                  </a> -->
                </h4>
              </div>
              <p class="description text-center">
                "User bio..."
              </p>
              <p class="description text-center">
                {{ identity.accessToken }}
              </p>
            </div>
          </b-card>
        </div>
        <div class="col-xl-8 col-lg-7 col-md-6">
          <b-card class="card-profile">
            <p>
              {{ identity }}
            </p>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
